import * as actionTypes from "./actionTypes";

export const setValidationUILoginForm=(validationObject)=>{
    return{
        type:actionTypes.SET_VALIDATION_UI_LOGIN_FORM,
        payload:{
            ...validationObject
        }

    }
}